import "./utils/Polyfills.js";
import NuCalController from "./controllers/NuCalController.js";
import NuCalAnnouncerView from "./views/NuCalAnnouncerView.js";
import NuCalSelectView from "./views/NuCalSelectView.js";
import NuCalSingleCalendarView from "./views/NuCalSingleCalendarView.js";
import NuCalNumberOfNightsView from "./views/NuCalNumberOfNightsView.js";
import NuCalSingleCalendarWidget from "./views/composites/NuCalSingleCalendarWidget.js";


import LexiconManager from "./utils/lexicon";
import deDE from "./utils/lexicon/translations/de-DE";

LexiconManager.addLexicon("de-DE",deDE);

window.NuCalController = NuCalController;

window.NuCalAnnouncerView = NuCalAnnouncerView;
window.NuCalSelectView = NuCalSelectView;
window.NuCalSingleCalendarView =  NuCalSingleCalendarView;
window.NuCalNumberOfNightsView = NuCalNumberOfNightsView;
window.NuCalSingleCalendarWidget = NuCalSingleCalendarWidget;